import React from 'react';
import { TeamTerritoriali } from '../layouts/TeamTerritorialiPage';

const Page = () => <TeamTerritoriali title="Team Territoriali" />;
export default Page;
